module.exports = __webpack_public_path__ + "static/media/badge1.2b7284fd.svg";